import { Component, OnInit, ApplicationRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../api';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastService } from '../../../../shared/service/toast.service';
@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})

export class ResetComponent implements OnInit {
  params;
  resetForm: FormGroup;
  success = false;
  constructor(
    private route: ActivatedRoute,
    private toast: ToastService,
    private as: AccountService,
    private app: ApplicationRef
  ) {
    this.success = false;
    this.route.queryParams.subscribe(
      _params => {
        this.params = _params;
      });
  }

  ngOnInit() {
    this.resetForm = new FormGroup({
      password: new FormControl(null, [
        Validators.required,
      ]),
      repassword: new FormControl(null, [
        Validators.required
      ]),
    }, validPassword);
  }
  get password() { return this.resetForm.get('password'); }
  get repassword() { return this.resetForm.get('repassword'); }
  valid() {
    this.app.tick();
  }
  reset() {
    const data = {
      email: decodeURIComponent(this.params.email),
      token: decodeURIComponent(this.params.token),
      password: this.resetForm.get('password').value
    };
    this.as.apiAccountsResetpwConfirmPost(data)
      .subscribe(() => {
        this.success = true;
      }, error => {
        this.toast.showError(error.headers.get('status'));
      });
  }
}

function validPassword(form: FormGroup): { [key: string]: boolean } {
  if (form.get('password').value && (form.get('password').value !== form.get('repassword').value)) {
    return { 'invalidRepassword': true };
  }
  return null;
}
